import { JSX } from 'react';

export const RowItem = ({
  title,
  value,
}: {
  title: string;
  value: JSX.Element;
}) => {
  return (
    <>
      {/* Mobile layout (default) */}
      <div className="block sm:hidden bg-gray-50 p-3 rounded-lg">
        <div className="text-sm text-black font-semibold">{title}</div>
        <div className="mt-1">{value}</div>
      </div>

      {/* Desktop layout (sm breakpoint and above) */}
      <div className="hidden sm:grid grid-cols-[1fr,auto] gap-x-4 items-center px-4 py-2 rounded-xl bg-gray-100">
        <span className="font-bold">{title}</span>
        <div className="text-left">{value}</div>
      </div>
    </>
  );
};
